/** AntD display fields are not part of the Controller attachment input. */
export const attachmentView = (file) => ({
  ...file, name: file.filename, type: file.mime_type,
  error_code: file.error?.code ?? '', error_message: file.error?.message ?? '',
});
